/** FILE FOR GLOBAL FUNCTIONS AND EVENTS -- this file is at the top of the minified file, so these functions can be used in all js files without having to export them and import in the file */

/**
 * FUNCTIONS
 */

// Debounce
function debounce(func, timeout = 300) {
	let timer;

	return (...args) => {
		clearTimeout(timer);
		timer = setTimeout(() => {
			func.apply(this, args);
		}, timeout);
	};
}

// scroll to a certain point on the page
function scroll(offsetTop, modifier = -0, duration = 1) {
	$("html,body").animate(
		{
			scrollTop: $(offsetTop).offset().top + modifier,
		},
		duration
	);
}

// Filters
function getFilterKey(dropdown_id) {
	return dropdown_id.substring(0, dropdown_id.indexOf("_dropdown"));
}

function emptyObject(object) {
	const objectKeys = Object.keys(object);

	objectKeys.forEach((key) => {
		object[key] = "";
	});
}

// reset the dropdowns to have the original title - used when clicking view all buttons
function resetDropdowns() {
	const dropdowns = document.querySelectorAll(".select-dropdown");

	dropdowns.forEach((dropdown) => {
		const id = `#${dropdown.id}`;

		$(`${id} .label span`).text($(`${id} .label span`).data("title"));
		$(`${id} .options .link span.active`).removeClass("active");
		$(`${id} .options.open`).removeClass("open");
	});
}

// dropdowns

function checkActive(target) {
	return target.children("span").hasClass("active");
}

// pagination functions

function removePaginationClasses() {
	$(`.pagination_custom.${paginationPrevPageClassName}`).removeClass(paginationPrevPageClassName);
	$(`.pagination_custom.${paginationCurrentPageClassName}`).removeClass(paginationCurrentPageClassName);
	$(`.pagination_custom.${paginationNextPageClassName}`).removeClass(paginationNextPageClassName);
}

function updatePagination(newPageNum, pages, prevPageNum, nextPageNum) {
	const reAddClasses = () => {
		$(`.pagination_custom[data-page=${prevPageNum}]`).addClass(paginationPrevPageClassName);

		if (nextPageNum <= pages) {
			$(`.pagination_custom[data-page=${nextPageNum}]`).addClass(paginationNextPageClassName);
		}

		$(`.pagination_custom[data-page=${newPageNum}]`).addClass(paginationCurrentPageClassName);
	};

	const updateButtons = () => {
		$("#prev").attr("disabled", newPageNum === 1);
		$("#next").attr("disabled", newPageNum === pages);
	};

	removePaginationClasses();
	reAddClasses();
	updateButtons();
}

function toggleShowPagination(show) {
	$("#pagination").css("opacity", show ? 1 : 0);

	$("#pagination .pagination_custom, #pagination .arrow-button").css("pointer-events", show ? "all" : "none");
}

// getNewPageNumbers() returns the page numbers for neww current page, next page and previous page
function getNewPageNumbers(e) {
	const btn = $(e.target);
	const btnId = btn.attr("id");
	const currentPageNum = parseInt($(`.${paginationCurrentPageClassName}`).data("page"));

	let prevPage, newPage, nextPage;

	if (btnId === "prev") {
		prevPage = currentPageNum - 2;
		newPage = currentPageNum - 1;
		nextPage = currentPageNum;
	} else if (btnId === "next") {
		prevPage = currentPageNum;
		newPage = currentPageNum + 1;
		nextPage = currentPageNum + 2;
	} else {
		prevPage = btn.data("page") - 1;
		newPage = btn.data("page");
		nextPage = btn.data("page") + 1;
	}

	return { newPage, prevPage, nextPage };
}

function togglePlayVideo(videoElement) {
	const video = $(videoElement);
	const playButton = video.siblings(".playpause");

	const play = () => {
		video.get(0).play();
		$(playButton).fadeOut();
	};

	const pause = () => {
		video.get(0).pause();
		$(playButton).fadeIn();
	};

	video.get(0).paused ? play() : pause();
}

function updateFieldLabelPosition(field, target) {
	if (!field.length) {
		field = $(".search_label");
	}

	if (target.value == "") {
		field.removeClass("has-value");
	} else if (!field.hasClass("has-value")) {
		field.addClass("has-value");
	}
}

function toggleShowResults(element, showOrHide) {
	const noResults = $("#no-results");

	if (showOrHide == "show") {
		$(element).show();
		noResults.hide();
	} else if (showOrHide == "hide") {
		$(element).hide();
		noResults.show();
	}
}
